/**
 * O seletor de EMPRESA da página (D-131) — "Todas as empresas" ou uma delas.
 *
 * ## Por que na página, e não no menu
 *
 * O menu da conta troca o PORTAL, que é onde a pessoa está. A empresa é um recorte DENTRO do
 * portal, como o período: governa todos os blocos da página, e quem lê os números precisa ver
 * o recorte ao lado deles, não escondido atrás de um clique no cabeçalho.
 *
 * ## A troca é da SESSÃO
 *
 * Escolher uma empresa não filtra nada na tela: é um POST de contexto, e a página inteira se
 * remonta com o que a sessão confirmou. Filtrar aqui seria uma segunda regra de recorte, ao
 * lado da RLS, e as duas um dia discordariam. A empresa também não entra na URL (R-05).
 *
 * O controle é o `SeletorComCapa`: em tela larga a capa desenhada, no toque o nativo.
 */
import { useEffect } from 'react'
import type { EmpresaDoPortalNoExterno, PortalDoExterno } from '@dv/contracts'
import { SeletorComCapa } from './capa.js'

const ID_DO_SELETOR = 'portal-empresa'

export function SeletorDeEmpresa({
  portal,
  empresa,
  aoTrocar,
  focarAoMontar,
}: {
  portal: PortalDoExterno
  /** null = Todas as empresas. */
  empresa: EmpresaDoPortalNoExterno | null
  aoTrocar: (empresa: EmpresaDoPortalNoExterno | null) => void
  /** Depois da troca a página se remonta: o foco volta para cá, e não para o começo da página. */
  focarAoMontar: boolean
}) {
  useEffect(() => {
    if (focarAoMontar) document.getElementById(ID_DO_SELETOR)?.focus()
  }, [focarAoMontar])

  return (
    <div className="seletor-de-empresa" data-teste="seletor-de-empresa">
      <label htmlFor={ID_DO_SELETOR}>Empresa</label>
      <SeletorComCapa
        id={ID_DO_SELETOR}
        value={empresa?.id ?? ''}
        onChange={(evento) => {
          const id = evento.target.value
          // A capa reescreve o valor mesmo quando se escolhe o corrente: não é troca.
          if (id === (empresa?.id ?? '')) return
          if (id === '') {
            aoTrocar(null)
            return
          }
          const escolhida = portal.empresas.find((item) => item.id === id)
          if (escolhida !== undefined) aoTrocar(escolhida)
        }}
        data-teste="filtro-empresa"
      >
        <option value="">Todas as empresas</option>
        {portal.empresas.map((item) => (
          <option key={item.id} value={item.id}>
            {item.nome}
          </option>
        ))}
      </SeletorComCapa>
    </div>
  )
}
